import { connect } from 'react-redux';
import { isUserLoggedIn } from 'apps/user/helpers';

import Regulars from '../components/partials/Regulars';

import {
  requestSubscribe,
  requestFrequencyChange,
  requestQuantityChangeOrDelete,
} from 'apps/subscriptions/actions/subscriptions';

export default connect(
  (state, ownProps) => {
    const { sku } = ownProps;
    const subscription = state.subscriptions.subscriptionsBySku[sku];
    return {
      sku,
      isLoggedIn: isUserLoggedIn(state.user),
      ...subscription,

    };
  },
  {
    requestSubscribe,
    requestFrequencyChange,
    requestQuantityChangeOrDelete,
  }
)(Regulars);
